import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Typography } from 'components/core';

const NavigationTypography = styled(Typography)``;

const NavigationLink = styled(NavLink)`
  ${NavigationTypography} {
    border-bottom: 5px solid transparent;
    display: inline-block;
  }

  &.selected {
    ${NavigationTypography} {
      border-color: var(--color-header-navigation-text);
      color: var(--color-header-navigation-text);
    }
  }
`;

export const Styled = {
  NavigationLink,
  NavigationTypography,
};
